<script lang="ts" setup>
import BaseContent from "@/components/BaseContent.vue";
import CharacterStat from "@/components/CharacterStat.vue";
import { computed } from "vue";

const props = defineProps<{
    character: Character;
    eza?: boolean;
    potentialUnlocked?: boolean;
    lv?: boolean;
    cost?: boolean;
    ki?: boolean;
}>();

const calculateStat = (stat: string) => {
    return (
        (props.eza && props.character.rarity < 5
            ? props.character[stat].eza
            : props.character[stat].max) +
        (props.potentialUnlocked ? props.character.hidden_potential?.[stat] : 0)
    );
};

const hp = computed(() => calculateStat("hp"));
const atk = computed(() => calculateStat("atk"));
const def = computed(() => calculateStat("def"));
</script>

<template>
    <BaseContent>
        <div
            class="grid grid-cols-3 items-start justify-between gap-2"
            v-bind="$attrs"
        >
            <CharacterStat v-if="lv" :value="character.lv_max" type="Max Lv." />
            <CharacterStat v-if="cost" :value="character.cost" type="Cost" />
            <CharacterStat
                v-if="ki"
                :type="`Ki Multiplier${
                    character.ki_multipliers.mid.ki ? 's' : ''
                }`"
            >
                <span v-if="character.ki_multipliers.mid.ki">
                    <span class="text-green-100">{{
                        character.ki_multipliers.mid.ki
                    }}</span>
                    {{ character.ki_multipliers.mid.multiplier }}%<br />
                </span>
                <span class="text-green-100">{{
                    character.ki_multipliers.max.ki
                }}</span>
                {{ character.ki_multipliers.max.multiplier }}%
            </CharacterStat>
            <CharacterStat :value="hp" type="HP" />
            <CharacterStat :value="atk" type="ATK" />
            <CharacterStat :value="def" type="DEF" />
        </div>
    </BaseContent>
</template>

<style scoped></style>
